import { Injectable } from '@angular/core';
import { TransactionDetailsFormatterService } from '@rd/core/services/transaction-details-formatter/transaction-details-formatter.service';
import { DynamicListItem } from '@rd/shared-legacy/components/dynamic-list/dynamic-list-item.type';
import { LoyaltyProgram, PointsTransferMembership } from '@rd/types';

@Injectable({
  providedIn: 'root',
})
export class VmaTransactionDetailsFormatterService extends TransactionDetailsFormatterService {
  pointsTransferDetailsFormat(params: {
    loyaltyProgram: Partial<LoyaltyProgram>;
    pointsTransferData: Partial<PointsTransferMembership>;
    processingDelay: number;
  }): DynamicListItem[] {
    const { loyaltyProgram, pointsTransferData } = params;
    return [
      {
        translationKey: 'transfer_v2.review.membership_details_title',
        htmlTag: 'p',
        cssClass: 'membership-details-title',
        value: {
          loyaltyProgramName: loyaltyProgram.name,
        },
      },
      {
        value: pointsTransferData.number,
        htmlTag: 'p',
        cssClass: 'membership-details-information',
      },
      {
        value: `${pointsTransferData.firstName} ${pointsTransferData.lastName}`,
        htmlTag: 'p',
        cssClass: 'membership-details-information',
      },
    ];
  }
}
